<template>
    <img :src="logoUrlNoTagline"
         alt="Normal-logo"
         class="logo">
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import logoUrlNoTagline from '@/assets/images/logo-notagline.svg';

export default defineComponent({
    name: 'Logo',
    setup() {
        return {
            logoUrlNoTagline,
        };
    },
});
</script>

<style scoped>
    .st0{fill:#1D1D1B;}
    .st1{fill:#FFFFFF;}
</style>
